<template>
  <div class="choose-element-type-list-elements flex flex-wrap items-start overflow-x-hidden">
    <button
      @click="onHandleModelClick(element)"
      :title="`Название: ${element.name}; Артикул: ${element.article}`"
      class="choose-element-type-list-element focus:outline-none"
      :class="{
                selected: selected && element.element_id == selected.element_id
            }"
      v-for="(element, endx) in type.elements"
      :key="`manage-element-${endx}`"
    >
      <i
        class="fas fa-check absolute top-2 right-2"
        v-if="selected && element.element_id == selected.element_id"
      ></i>
      <div class="img">
        <img
          class="object-cover"
          :src="element.image"
          :alt="`Название: ${element.name}; Артикул: ${element.article}`"
        />
      </div>
      <div
        class="article w-full"
        :title="element.article"
      >{{ $shortArticle(element.article) }}</div>
    </button>
    <Loading
      class="mt-2 ml-2"
      v-if="type.meta && type.meta.current_page < type.meta.last_page"
      :id="`elements__loader-${type.type_id}`"
    ></Loading>
  </div>
</template>
<script>
export default {
  name: "ElementSidebarElements",
  props: {
    type: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object,
      default: null,
    },
  },
  methods: {
    onHandleModelClick(element) {
      if (this.selected && element.element_id == this.selected.element_id) {
        this.$store.dispatch("clientOrder/removeElement", element.element_id);
      } else {
        this.$store.dispatch("clientElements/selectElement", element);
      }
    },
  },
  async mounted() {
    if (this.selected && this.selected.type_id == this.type.type_id) {
      this.$store.dispatch(
        "clientElements/clearTypeElements",
        this.type.type_id
      );
      let showSelected = false;
      let currentPage =
        (this.type && this.type.meta && this.type.meta.current_page) || 1;
      let lastPage =
        (this.type && this.type.meta && this.type.meta.last_page) || null;

      while (!showSelected || currentPage == lastPage) {
        this.type.elements.forEach((el) => {
          if (el.element_id == this.selected.element_id) {
            showSelected = true;
          }
        });
        if (!showSelected) {
          await this.$store.dispatch(
            "clientElements/getElementsByType",
            this.type.type_id
          );
        }
      }
    }
    this.$emit("mountedElements");
  },
  unmounted() {
    if (this.selected && this.selected.type_id == this.type.type_id) {
      this.$store.dispatch(
        "clientElements/clearTypeElements",
        this.type.type_id
      );
    }
  },
};
</script>
